export const SET_CHEQUE = "SET_CHEQUE";
export const SET_CHEQUES = "SET_CHEQUES";
